import useRestApi from "@/composable/useRestService";

const {findAll, findAllAttivi, insert, update, deleteRequest} = useRestApi('modelloemail');

export default {
    findAll, findAllAttivi, insert, update, deleteRequest
}
